
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
#chart-container {
  height: 100%;
  width: 100%;
}

.pie-legend {
  bottom: 0px;
  right: 0px;
}

.pie-legend .highcharts-legend-item rect {
  display: none;
}

.pie-legend .highcharts-legend-item-hidden .custom-dot{
      background-color:var(--gray-professional-lighten-1) !important;
    }

.pie-legend > div {
  bottom: inherit;
}

.pie-legend > div {
  right: inherit;
}

.pie-legend > div > div {
  bottom: inherit;
}

.pie-legend > div > div {
  right: inherit;
}

.pie-legend > div > div {
  display: grid;
}

.pie-legend > div > div {
  grid-template-columns: 1fr;
}

.pie-legend > div > div {
  grid-template-rows: auto;
}

.pie-legend > div > div {
  row-gap: 0.5rem;
}

.pie-legend > div > div {
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}

@media (min-width: 768px) {

  .pie-legend > div > div {
    grid-template-columns: 1fr 1fr;
  }
}

@media (min-width: 768px) {

  .pie-legend > div > div {
    grid-template-rows: auto auto;
  }
}

.pie-legend > div > div{
      position:initial !important;
    }

.pie-legend > div > div > .highcharts-legend-item {
  height: -moz-fit-content;
  height: fit-content;
}

.pie-legend > div > div > .highcharts-legend-item{
        position:initial !important;
      }

.pie-legend > div > div > .highcharts-legend-item > span{
          position:initial !important;
          white-space:normal !important;
        }

.pie-legend > div > div > .highcharts-legend-item > span .custom-dot {
  display: block;
}

.pie-legend > div > div > .highcharts-legend-item > span .custom-dot {
  height: 0.75rem;
}

.pie-legend > div > div > .highcharts-legend-item > span .custom-dot {
  width: 0.75rem;
}

.pie-legend > div > div > .highcharts-legend-item > span .custom-dot {
  --tw-translate-y: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.pie-legend > div > div > .highcharts-legend-item > span .custom-dot {
  border-radius: 9999px;
}

.pie-legend > div > div > .highcharts-legend-item > span .label {
  margin-left: 1rem;
} `;